"use strict";

export function getBodyHeight()
{
  const body = document.body,
        html = document.documentElement;

  let height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
  return height;
}

export function getDivHeight(id)
{
  const clientHeight = document.getElementById(id).clientHeight;  
  //const offsetHeight = document.getElementById('myDiv').offsetHeight;
  return clientHeight;
}

export function getDivWidth(id)
{
  const clientWidth = document.getElementById(id).clientWidth;  
  //const offsetWidth = document.getElementById('myDiv').offsetWidth;
  return clientWidth;
}

export function getDivSize(id)
{
  return { w: getDivWidth(id), h: getDivHeight(id) };
}

export function getBuildVersion(return_function)
  {
    if(return_function)
    {
      var _ret_func = return_function;

      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        let xmlDoc = xhr.responseXML;
        let ver = xmlDoc.getElementsByTagName("version")[0].getAttribute('v'); 
        _ret_func(ver);
      }
      xhr.onerror = function() {
        console.log("Tools:get_build_version() Error while getting XML.");
      }
      xhr.open("GET", "version.xml");
      xhr.responseType = "document";
      xhr.send();

      /* VERSION ES6 --- A VOIR
      let request = new Request('version.xml');
      fetch(request).then((results) => {
        // results returns XML. lets cast this to a string, then create
        // a new DOM object out of it!
        results
          .text()
          .then(( str ) => {
            let responseDoc = new DOMParser().parseFromString(str, 'application/xml');
            return responseDoc.getElementsByTagName('zpid')[0].textContent;
          }
        });
        */
    }
  }

  /* for touch interface */

  export function getGesturePointFromEvent(evt) {
    var point = {};

    if(evt.targetTouches) {
      point.x = evt.targetTouches[0].clientX;
      point.y = evt.targetTouches[0].clientY;
    } else {
      // Either Mouse event or Pointer Event
      point.x = evt.clientX;
      point.y = evt.clientY;
    }

    /* correction suite au passage responsive */
    /* il faut décaler point.x/y de la position du client */
    /*
    const rect = evt.target.getBoundingClientRect();
    const x = point.x;// - rect.left; //x position within the element.
    const y = point.y;// - rect.top;  //y position within the element.
    >> fait manuellement, dans InteractionMask.js, sinon pose problème dans le interactionPendule.js
    */
    //console.log(x,y);

    return { x: point.x, y: point.y };
  }

  /* is p{x,y} is in zone{x,y,w,h) */

  export function isInside( p, zone)
  {
    //console.log("isInside",p, zone)

    if( ( ( p.x > zone.left) && ( p.x < zone.right ) ) &&
        ( ( p.y > zone.top)  && ( p.y < zone.bottom ) ) )
        return true;
    return false;    
  }

  export function initRequestAnimFrame()
  {
  /* Shim for requestAnimationFrame from Paul Irishpaul ir
     http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
  */

  window.requestAnimFrame = (function(){
        'use strict';

        return  window.requestAnimationFrame       ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame    ||
                function( callback ){
                  window.setTimeout(callback, 1000 / 60);
                };
      })();
    }



// WEBPACK FOOTER //
// ./src/Tools.js